module.exports = __webpack_public_path__ + "img/lunch.94ce538f.png";